var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-select-plates-dropdown-content" }, [
    _c(
      "div",
      { staticClass: "custom-select-plates-dropdown-content__options-wrap" },
      _vm._l(_vm.options, function(option) {
        return _c("size", {
          key: option.value,
          staticClass: "custom-select-plates-dropdown-content__option",
          attrs: {
            title: option.label,
            "is-selected": _vm.isSelected(option),
            "is-out-of-stock": option.count === 0
          },
          nativeOn: {
            click: function($event) {
              return _vm.toggle(option)
            }
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }